import Hotjar from "@hotjar/browser";
import { useEffect, useRef } from "react";

export const HotjarConfig = () => {
  const hotjarInitializedRef = useRef(false);

  useEffect(() => {
    if (!hotjarInitializedRef.current) {
      hotjarInitializedRef.current = true;
      Hotjar.init(parseInt(`${process.env.NEXT_PUBLIC_HOTJAR_SITE_ID}`), 6);
    }
  }, []);

  return null;
};
